export default {
  computed: {
    loggedIn() {
      // determine whether the user has logged in
      // console.log('loggedIn() this.$store.state.user.token = %s', this.$store.state.user.token)

      return !!this.$store.state.user.token;
    },
  },
}
